export const isProduction = (): boolean => {
  return process.env.REACT_APP_IS_PROD === 'true';
};
